"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackJS = void 0;
const doNothing = () => {
};
const FakeTrackJS = {
    install: doNothing,
    addMetadata: doNothing,
    track: doNothing,
};
exports.TrackJS = typeof window === 'undefined' ? FakeTrackJS : require('trackjs').TrackJS;

//# sourceMappingURL=TrackJS.js.map
